document.addEventListener("DOMContentLoaded", function () {
  let imageSplideWhy = new Splide(".splide-why-information", {
    perPage: 3.2,
    focus: "left",
    gap: "12px",
    arrows: true,
    pagination: false,
    // trimSpace: false,
    breakpoints: {
      990: {
        perPage: 1.2,
        gap: "24px",
        arrows: false,
      },
    },
  });

  imageSplideWhy.mount();

  imageSplideWhy.on("mounted resize", function () {
    const totalSlides = imageSplideWhy.length;
    const perPage = imageSplideWhy.options.perPage;
    console.log(totalSlides, perPage);
    const arrowWrapper = document.querySelector(
      ".splide-why-information .splide__arrows"
    );

    if (arrowWrapper) {
      if (totalSlides <= perPage) {
        arrowWrapper.style.display = "none";
      } else {
        arrowWrapper.style.display = "";
      }
    }
  });

  // Manually bind arrow buttons if necessary
  document
    .querySelector(".splide-why-information .splide__arrow--prev")
    .addEventListener("click", function () {
      imageSplideWhy.go("<");
    });

  document
    .querySelector(".splide-why-information .splide__arrow--next")
    .addEventListener("click", function () {
      imageSplideWhy.go(">");
    });
});
